import { Paper, Typography } from '@material-ui/core'
import { useMemo } from 'react'
import SortableTable from '../../Table/SortableTable'
import { COLUMNS } from './columns'

const WebSocketsTable = ({ data = [], loading }) => {
  const columns = useMemo(() => COLUMNS, [])

  return (
    <Paper elevation={2}>
      <Typography variant="h5" gutterBottom style={{ margin: 20 }}>
        Websocket connections
      </Typography>
      <SortableTable data={data} columns={columns} loading={loading} />
    </Paper>
  )
}

export default WebSocketsTable
